import "./ChatUserInput.css";

const ChatUserInput = ({ input, setInput, isLoading, handleSubmit }) => {
  return (
    <div className="chat-input-holder">
      <form onSubmit={handleSubmit}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="chat-input-textarea"
          placeholder="Type your message here"
          disabled={isLoading}
        />
      </form>
    </div>
  );
};

export default ChatUserInput;
